import { render, staticRenderFns } from "./VotingSimpleCard.vue?vue&type=template&id=e87ba00c&scoped=true"
import script from "./VotingSimpleCard.vue?vue&type=script&lang=js"
export * from "./VotingSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./VotingSimpleCard.vue?vue&type=style&index=0&id=e87ba00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87ba00c",
  null
  
)

export default component.exports